<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Import Trajectories</h2>
      <div class="close" (click)="cancelImport()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active">
          <div class="fields__block" style="width: 100%">

            <div class="fields__block__section">
              <div class="title">
                <h4>{{format}} Source File</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File</label>
                  <input (change)="fileChange($event)" [accept]="getFileFormat()"
                    style="max-width: fit-content;padding-left: 0px;"
                    maxlength="300"
                    type="file"
                    name="trajectoryFileName"
                    id="trajectoryFileName"
                  />
                </div>
              </div>
            </div>

            <div class="fields__block__section">
              <div class="title">
                <h4>Settings</h4>
                <span> </span>
              </div>

              <!--<div class="dropdown-fields">
                <div>
                  <label for="">Field Separator</label>
                  <select name="trajectoryProcedures" id="trajectoryProcedures" required (change)="selectProcedure($event.target.value)">
                    <option *ngFor="let proc of this.procedures" [value]="proc.procedureid">{{proc.name}}</option>
                  </select>
                </div>
              </div>

              <div class="input-fields">
                <div>
                  <label for="">Procedure Identifier</label>
                  <input  [(ngModel)]="trajectoryProcedureId"
                    type="text" name="trajectoryProcedureId" id="trajectoryProcedureId" [disabled]="isNewProc ? false : true" required/>
                </div>
              </div>

              <div class="input-fields">
                <div>
                  <label for="">Procedure Name</label>
                  <input [(ngModel)]="trajectoryProcedureName"
                    type="text" name="trajectoryProcedureName" id="trajectoryProcedureName" [disabled]="isNewProc ? false : true" required/>
                </div>
              </div>

              <div class="dropdown-fields">
                <div>
                  <label for="">Procedure Type</label>
                  <select [(ngModel)]="trajectoryProcedureType"
                    name="trajectoryProcedureType" [disabled]="isNewProc ? false : true" >
                      <option value="SID">SID</option>
                      <option value="STAR">STAR</option>
                      <option value="EN-ROUTE">EN-ROUTE</option>
                    </select>
                </div>
              </div>

              <div class="dropdown-fields">
                <div>
                  <label for="">RNAV Performance Type</label>
                  <select [(ngModel)]="trajectoryProcedureRNAVType"
                    name="trajectoryProcedureRNAVType" [disabled]="isNewProc ? false : true" >
                    <option value="B_RNAV">RNAV-5 (B-RNAV)</option>
                    <option value="P_RNAV">RNAV-1 (P-RNAV)</option>
                    <option value="A_RNP">A-RNP</option>
                  </select>
                </div>
              </div>-->

              <div class="input-fields">
                <div>
                  <label for="">Trajectory Name</label>
                  <input [(ngModel)]="trajectory.name"
                    maxlength="50" type="text" name="trajectoryName"
                     id="trajectoryName" required alphaNumeric #name="ngModel" />
                     <span class="error" *ngIf=" (name.dirty || name.touched)
                     && name.errors?.nonAlphaNumeric">
                       Only alphanumeric characters, hyphens and underscores are allowed.
                     </span>
                </div>
              </div>

            </div>
          </div>

          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();"  [disabled]="!ngForm.form.valid">
              Import
            </button>
            <button class="gray" (click)="cancelImport()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
